import React from 'react';
import PropTypes from 'prop-types';

const ErrorPage = ({
    code = '',
    message = 'An Unknown error occurred while processing your request',
    subMessage = '',
}) => (
    <div className="max-w-4xl mx-auto w-full px-2 py-4 mt-6 mb-6">
        <div className={'px-4 sm:px-10 bg-red-200 w-5/6 mx-auto rounded'}>
            <div className="pt-10 pb-4 text-red-700 text-2xl font-semibold">
                <div className="font-bold text-6xl"> {code} </div>
                {message.split('.').map((str, index) => {
                    if (str)
                        return (
                            <React.Fragment key={index}>
                                {str} <br />
                            </React.Fragment>
                        );
                    return <React.Fragment key={index}> </React.Fragment>;
                })}
            </div>
            <div className="pb-10">{subMessage}</div>
        </div>
    </div>
);

ErrorPage.propTypes = {
    code: PropTypes.string,
    message: PropTypes.string,
    subMessage: PropTypes.object,
};

export default ErrorPage;
